module.exports = __webpack_public_path__ + "img/new_health_tips_icon.2da2401.png";